import {
    Add,
    CalendarTodayTwoTone, Delete, Edit, GridOn
} from "@material-ui/icons";
import axios from "axios";
import React from "react";
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import FloatingActionButton from "../../../components/floating_action_btn/FloatingActionButton";
import UrlArgsBundle from "../../../core/url_args_bundle";
import { createApiServerRoute } from "../../../models/network/api_client";
import { actionSetStandardGames } from "../../../models/redux/reducers/activity_main_reducers/games_reducer/action_games";
import { ACTIVITY_TAG, API_KEY, FRAGMENT_TAG, GAME_TYPES } from "../../../utils/constants";

class FcGameFragment extends React.Component {

    urlArgsBundle = new UrlArgsBundle();
    getAddStandardGameFragment = (fragmentTag) => {
        this.urlArgsBundle.setActivityTag(ACTIVITY_TAG.MAIN).setFragmentTag(fragmentTag);
        return this.urlArgsBundle.getArgsAsUrlParams()
    }

    componentDidMount() {
        const params = new URLSearchParams();
        params.append("__api_key__", API_KEY)
        const config = {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            }
        };

        axios.post(createApiServerRoute('get_all_games_meta.php'), params, config)
            .then(res => {
                if (res.data.state === 'OK') {
                    this.props.actionSetStandardGames(res.data.data.fcGames)
                }
            });

    }

    render() {
        console.log(this.props.standardGames)

        let user = JSON.parse(localStorage.getItem('user'))

        return <>

            <div className="w-full game-cards flex gap-x-6 gap-y-10 flex-wrap justify-center p-16">
                {
                    this.props.standardGames.map((card, index) => {
                        return <div className={"card bg-gray-200 min-w-md rounded-lg"}>
                            <div key={index} className="card-header px-6 py-3 rounded-tr-xl rounded-tl-xl bg-blue-800 font-semibold text-white items-center flex justify-between">
                                <h1 className={"text-2xl text-white"}>{card.name}</h1>
                                <div className="card-options flex justify-left items-center gap-4">
                                    {
                                        user === null ? '' : (user['type'] === 'MAIN' ? <Edit className={"ml-16 cursor-pointer"} style={{ fontSize: '1.2rem' }} onClick={
                                            () => {
                                                this.urlArgsBundle.putExtra('game_uid', card.uid)
                                                this.props.history.push(this.getAddStandardGameFragment(FRAGMENT_TAG.UPDATE_FC_GAME))
                                            }}
                                        /> : '' )}
                                </div>
                            </div>
                            <div className="card-body py-4 flex flex-col gap-1 items-center justify-center ">
                                <h3>Open Time : <span className={"text-indigo-800"}>{card.open_time}</span></h3>
                                <h3>Close Time : <span className={"text-indigo-800"}>{card.close_time}</span></h3>
                            </div>
                        </div>
                    })
                }
            </div>
        </>
    }
}

const mapStateToProps = rootReducer => ({
    standardGames: rootReducer.gameReducer.games.currentStandardGames
})

const mapDispatchToProps = dispatch => ({
    actionSetStandardGames: standardGames => dispatch(actionSetStandardGames(standardGames))
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(FcGameFragment));
